import type { Team } from './team';

export interface IExperience {
  id: number;
  start: string;
  end: string | null;
}

export interface UserTracker {
  id: number;
  name: string;
  permissions: {
    canUpload: boolean;
  };
  token: string;
  url: string;
}

export type KeitaroDomain = string;

interface KeitaroCreds {
  token: string;
  canUpload: boolean;
}

export interface UserPermissions {
  keitaro?: Record<KeitaroDomain, KeitaroCreds>;
  limitAccountPurchase?: number;
  canManageAffiliates?: boolean; // Создание, редактирование ПП и Категорий на страницах Партнерки
  canViewTrackers?: boolean;
  viewVideosPage?: boolean;
  viewTasksBoardPage?: boolean;
  viewUsersPage?: boolean;
  viewTasksBoardStatsPage?: boolean;
  viewCapiPage?: boolean;
  viewCandidatesPage?: boolean;
  canSeeOfferSid?: boolean; // Для ролей BUYER+, BIZDEV и MANAGER всегда видят SID
}

export interface User {
  id: number;
  name: string;
  login: string;
  role: Role;
  isGold?: boolean;
  isActive: boolean;
  email: string;
  createdAt: string;
  birthday?: string;
  teams?: Pick<Team, 'id' | 'name' | 'teamLeads'>[];
  assignedUsers?: Pick<User, 'id' | 'name' | 'avatar' | 'isActive' | 'role'>[];
  experience: IExperience[];
  dismissal?: {
    date?: string;
    reason?: string;
  };
  avatar?: string;
  phone?: string;
  telegram?: string;
  permissions?: UserPermissions;
  trackers?: UserTracker[];
  management?: {
    id: number;
    name: string;
    role: Role;
  }[];
}

export const RoleList = [
  'ADMIN',
  'PARTNER',
  'HEAD',
  'TEAM_LEAD',
  'BUYER',
  'BIZDEV',
  'MANAGER',
  'FARMER',
  'HR',
  'NEW_USER',
] as const;
export type Role = (typeof RoleList)[number];

export const StatusList = ['ACTIVE', 'INACTIVE'] as const;
export type Status = (typeof StatusList)[number];

export const UserPermissionTypeList = ['LIMIT_ACCOUNTS', 'KEITARO_CREDS'] as const;
export type UserPermissionType = (typeof UserPermissionTypeList)[number];
